import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  FeatureGroup,
  LayersControl,
  Circle,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import {
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Expand } from "../../../Components/IconComponents";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { GeoJSON } from "react-leaflet";
import {
  districtsInGis,
  getGisData,
  gisCoordinatesData,
  gisStateCoordinates,
} from "../../../Services/EndPoints";
import { getData } from "../../../Services/Services";
import { toast } from "react-toastify";

// Custom Icons using SVG strings
const createCustomIcon = (svg, color) => {
  return L.divIcon({
    className: "custom-icon",
    html: `<div style="color: ${color}; font-size: 24px;">${svg}</div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12],
  });
};
const atmIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="none">
  <rect x="32" y="64" width="384" height="384" rx="24" fill="#333" stroke="#333" stroke-width="16"/>
  <rect x="96" y="112" width="256" height="96" rx="8" fill="#fff" stroke="#333" stroke-width="8"/>
  <rect x="96" y="232" width="256" height="32" rx="4" fill="#fff" stroke="#333" stroke-width="8"/>
  <circle cx="144" cy="296" r="12" fill="#fff"/>
  <circle cx="176" cy="296" r="12" fill="#fff"/>
  <circle cx="208" cy="296" r="12" fill="#fff"/>
  <circle cx="144" cy="328" r="12" fill="#fff"/>
  <circle cx="176" cy="328" r="12" fill="#fff"/>
  <circle cx="208" cy="328" r="12" fill="#fff"/>
</svg>`;

const branchIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="#B22222">
  <path d="M0 464V256H64V464H160V352H288V464H384V320H512V464H640V224L320 0 0 224V464z"/>
</svg>`;
const incidentIconSvg = `  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 512 512"
    {...props}
  >
    <path fill="red" d="M53 33c-1.2 1.2-2 3.3-2 5.3 0 2.9 2.9 6.1 30.3 33.5 32.3 32.2 33.1 32.8 37.7 28.2 1.9-1.9 2.5-3.8 2.1-7-.2-.8-13.8-15.1-30.4-31.8C58.4 28.9 57.7 28.3 53 33M421.3 61.2c-16.6 16.7-30.2 31-30.4 31.8-.4 3.2.2 5.1 2.1 7 4.6 4.6 5.4 4 37.7-28.2C458.1 44.4 461 41.2 461 38.3c0-4.1-3-7.3-6.8-7.3-2.2 0-7.9 5.2-32.9 30.2M234.5 59c-41.4 7.5-74.4 29.9-95.6 64.7-10.4 17.1-16.9 37.4-18.9 58.8-.6 6.6-1 49.7-1 108.7V389h112.8c62.1 0 123.8.3 137.1.7l24.2.6-.4-106.9c-.3-104.3-.4-107.1-2.4-116.4-2.6-11.5-7.3-25.1-12-34.4-18.9-37.6-55.2-65.1-96.4-73.1-13.5-2.6-34.3-2.9-47.4-.5m49.2 55c4.9 3.2 5 2.4-2.7 73.2-3.9 36.5-7.6 68-8.1 70-2 7.7-8.9 13-16.9 13s-14.9-5.3-16.9-13c-1.6-6.1-15.3-135.3-14.6-137.9.6-2.7 3.6-5.5 6.8-6.5 1.2-.4 13-.6 26.2-.5 19.2.2 24.4.5 26.2 1.7M264 299.9c9.1 4.8 12.7 16.2 7.8 24.6-7.3 12.5-24.3 12.5-31.6 0-3.3-5.8-2.7-14 1.4-19.1 3.9-4.9 8.8-7.4 14.4-7.4 2.5 0 6.1.8 8 1.9M2.5 218.5c-1.4 1.3-2.5 3.1-2.5 4 0 2 1.9 5.7 3.4 6.7.6.4 20.5.8 44.2.8 41.9 0 43.1-.1 44.9-2 2.6-2.9 2.4-7.9-.4-10.2-2.2-1.7-5-1.8-44.8-1.8H4.9zM419.9 217.8c-2.8 2.3-3 7.3-.4 10.2 1.8 1.9 3 2 44.9 2 23.7 0 43.6-.4 44.2-.8 1.5-1 3.4-4.7 3.4-6.7 0-.9-1.1-2.7-2.5-4l-2.4-2.5h-42.4c-39.8 0-42.6.1-44.8 1.8M65.6 438.1l-2.6 2v18.4c0 17.7.1 18.5 2.2 20.5 2.2 2 2.4 2 190.9 2 184.2 0 188.7 0 191-1.9s2.4-2.5 2.7-18.2c.4-17.8.1-20-2.8-22.9-2-2-4.1-2-190.4-2H68.3z" />
  </svg>`;

// Create icon instances
const atmIcon = createCustomIcon(atmIconSvg, "#0066cc");
const branchIcon = createCustomIcon(branchIconSvg, "#006600");

// Color-coded incident icons based on severity
const getIncidentIcon = (severity) => {
  const colors = {
    Low: "#c19a6b", // Tan
    Medium: "#a0522d", // Sienna (reddish-brown)
    High: "#cc0000", // Red
    Critical: "#800000", // Maroon
  };

  return createCustomIcon(incidentIconSvg, colors[severity] || "#cc0000");
};

const MapUI = () => {
  const handle = useFullScreenHandle();
  const [showATMs, setShowATMs] = useState(false);
  const [showBranches, setShowBranches] = useState(true);
  const [showIncidents, setShowIncidents] = useState(false);
  const [showServices, setShowServices] = useState(true);
  const [showRegionHierarchy, setShowRegionHierarchy] = useState(true);
  const [activeTab, setActiveTab] = useState("Region");
  const [kilometerRange, setKilometerRange] = useState(40);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showDistricts, setShowDistricts] = useState(false);
  const [DistrictList, setDistrictList] = useState([]);
  const [districtCoordinates, setDistrictCoordinates] = useState({});
  const [hoveredDistrict, setHoveredDistrict] = useState(null);
  const [mapData, setMapData] = useState({
    branches: [],
    atms: [],
    incidents: [],
  });
  const [selectedLayers, setSelectedLayers] = useState({
    regionLayer: true,
    state: false,
    block: true,
  });
  const [drawnShapes, setDrawnShapes] = useState([]);
  const [filteredEntities, setFilteredEntities] = useState({
    branches: null,
    atms: null,
    incidents: null,
  });
  const [stateGeoJSON, setStateGeoJSON] = useState([]);
  const [activeDistricts, setActiveDistricts] = useState({});
  const [selectAllDistricts, setSelectAllDistricts] = useState(false); // Controls selection
  const [districts, setDistricts] = useState([]);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [showRangeCircle, setShowRangeCircle] = useState(false);

  const drawRef = useRef();

  useEffect(() => {
    fetchGisData();
    fetchDistrictList();
    mapStateCoordinates();
  }, []);

  // Extract unique districts from branches after data is loaded
  useEffect(() => {
    if (mapData.branches.length > 0) {
      const uniqueDistricts = [
        ...new Set(mapData.branches.map((branch) => branch.district)),
      ];
      setDistricts(uniqueDistricts);
    }
  }, [mapData.branches]);

  const handleDrawCreated = (e) => {
    const shape = e.layer.toGeoJSON();

    // For circles, we need to extract the center and radius
    if (e.layerType === "circle") {
      const center = e.layer.getLatLng();
      const radius = e.layer.getRadius(); // in meters
      shape.properties = {
        ...shape.properties,
        center: [center.lat, center.lng],
        radius: radius,
        isCircle: true,
      };
    }

    const newDrawnShapes = [...drawnShapes, shape];
    setDrawnShapes(newDrawnShapes);
    filterEntitiesInShapes(newDrawnShapes);
  };

  // Add this filtered districts computation after your other useMemo hooks
  const filteredDistricts = useMemo(() => {
    if (!searchTerm.trim()) {
      return DistrictList;
    }
    return DistrictList.filter((district) =>
      district.value.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [DistrictList, searchTerm]);

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in kilometers
    return d;
  };

  // Add this function to filter data by distance
  const filterDataByDistance = (data, centerPoint, radiusKm) => {
    if (!centerPoint || !data) return data;

    return data.filter((item) => {
      const distance = calculateDistance(
        centerPoint[0],
        centerPoint[1],
        item.position[0],
        item.position[1]
      );
      return distance <= radiusKm;
    });
  };
  const filterEntitiesInShapes = (shapes) => {
    if (!shapes || shapes.length === 0) {
      setFilteredEntities({
        branches: null,
        atms: null,
        incidents: null,
      });
      return;
    }

    const filterEntity = (entity) => {
      return entity.filter((item) => {
        const point = [
          parseFloat(item.position[0]),
          parseFloat(item.position[1]),
        ];

        return shapes.some((shape) => {
          if (shape.properties?.isCircle) {
            // Handle circle filtering
            const distance = calculateDistance(
              shape.properties.center[0],
              shape.properties.center[1],
              point[0],
              point[1]
            );
            return distance <= shape.properties.radius / 1000; // convert meters to km
          } else {
            // Handle polygon/rectangle filtering
            return booleanPointInPolygon(
              [point[1], point[0]], // Note: lat/lng order for turf
              shape
            );
          }
        });
      });
    };

    setFilteredEntities({
      branches: filterEntity(mapData.branches),
      atms: filterEntity(mapData.atms),
      incidents: filterEntity(mapData.incidents),
    });
  };

  const districtFilteredData = useMemo(() => {
    const activeDistrictNames = Object.keys(activeDistricts).filter(
      (district) => activeDistricts[district]
    );

    // If no districts are selected or "select all" is active, return all data
    if (activeDistrictNames.length === 0 || selectAllDistricts) {
      return mapData;
    }

    return {
      branches: mapData.branches.filter((branch) =>
        activeDistrictNames.includes(branch.district)
      ),
      atms: mapData.atms.filter((atm) =>
        activeDistrictNames.includes(atm.district)
      ),
      incidents: mapData.incidents.filter((incident) =>
        activeDistrictNames.includes(incident.district)
      ),
    };
  }, [mapData, activeDistricts, selectAllDistricts]);
  const combinedFilteredData = useMemo(() => {
    // Start with district filtered data
    let baseData = districtFilteredData;

    // Apply drawn shapes filter if exists and has values
    const hasShapeFilters =
      filteredEntities.branches !== null ||
      filteredEntities.atms !== null ||
      filteredEntities.incidents !== null;

    if (hasShapeFilters) {
      baseData = {
        branches:
          filteredEntities.branches !== null
            ? filteredEntities.branches.filter((branch) =>
                districtFilteredData.branches.some((b) => b.id === branch.id)
              )
            : districtFilteredData.branches,
        atms:
          filteredEntities.atms !== null
            ? filteredEntities.atms.filter((atm) =>
                districtFilteredData.atms.some((a) => a.id === atm.id)
              )
            : districtFilteredData.atms,
        incidents:
          filteredEntities.incidents !== null
            ? filteredEntities.incidents.filter((incident) =>
                districtFilteredData.incidents.some((i) => i.id === incident.id)
              )
            : districtFilteredData.incidents,
      };
    }

    // Apply distance filter if a point is selected (only in Search tab)
    if (activeTab === "Search" && selectedPoint) {
      baseData = {
        branches: filterDataByDistance(
          baseData.branches,
          selectedPoint,
          kilometerRange
        ),
        atms: filterDataByDistance(
          baseData.atms,
          selectedPoint,
          kilometerRange
        ),
        incidents: filterDataByDistance(
          baseData.incidents,
          selectedPoint,
          kilometerRange
        ),
      };
    }

    return baseData;
  }, [
    districtFilteredData,
    filteredEntities,
    selectedPoint,
    kilometerRange,
    activeTab,
  ]);
  const handleMapClick = (e) => {
    if (activeTab === "Search") {
      const { lat, lng } = e.latlng;
      setSelectedPoint([lat, lng]);
      setShowRangeCircle(true);
    }
  };


  // Update the handleDrawDeleted function to properly reset filters
  const handleDrawDeleted = (e) => {
    const layers = e.layers;
    const remainingLayers = drawnShapes.filter((shape) => {
      return !layers.getLayers().some((layer) => {
        const layerGeoJSON = layer.toGeoJSON();
        return JSON.stringify(layerGeoJSON) === JSON.stringify(shape);
      });
    });

    setDrawnShapes(remainingLayers);

    if (remainingLayers.length === 0) {
      // If all shapes are deleted, reset all filters
      setFilteredEntities({
        branches: null,
        atms: null,
        incidents: null,
      });
    } else {
      // Otherwise, reapply filtering with remaining shapes
      filterEntitiesInShapes(remainingLayers);
    }
  };

  const fetchGisData = async () => {
    try {
      const response = await getData(getGisData);
      if (response) {
        // Process the data
        processResponseData(response);
      } else {
        console.error("Invalid data format:", response);
        toast.error("Failed to load GIS data");
      }
    } catch (error) {
      console.error("Error fetching GIS data:", error);
      toast.error("Failed to load GIS data");
    }
  };

  // Process the response data into the format needed for the map
  const processResponseData = (data) => {
    // Check if the data has the expected structure
    if (!data.branches_list || !data.atms_list || !data.incidents_list) {
      console.error("Data missing required lists");
      toast.error("Data format is incorrect");
      return;
    }

    // Transform branches data
    const branches = data.branches_list.map((branch) => ({
      id: branch.id,
      name: branch.branchName,
      position: [
        parseFloat(branch.latitude) || 25.59, // Fallback coordinates if missing
        parseFloat(branch.longitude) || 85.13,
      ],
      manager:
        branch.branch_contact && branch.branch_contact.length > 0
          ? `${branch.branch_contact[0].firstName} ${branch.branch_contact[0].lastName}`
          : "N/A",
      phones: branch.phoneNumber || "N/A",
      email: branch.email || "N/A",
      address: `${branch.addressLine1} ${branch.addressLine2 || ""}`,
      district: branch.district || "N/A",
      ifscCode: branch.ifscCode || "N/A",
      // Include original data to access all fields if needed
      originalData: branch,
    }));

    // Transform ATMs data
    const atms = data.atms_list.map((atm) => ({
      id: atm.id,
      name: atm.name,
      position: [
        parseFloat(atm.latitude) || 25.59, // Fallback coordinates if missing
        parseFloat(atm.longitude) || 85.13,
      ],
      status: atm.activeStatus ? "Working" : "Inactive",
      code: atm.code || "N/A",
      address: atm.addressLine || "N/A",
      district: atm.district || "N/A",
      // Include original data
      originalData: atm,
    }));

    // Replace this section in the processResponseData function:

    // Transform incidents data
    const incidents = data.incidents_list.map((incident) => {
      // Format date to dd/mm/yy
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear()).slice(-2); // Get last 2 digits of year
        return `${day}/${month}/${year}`;
      };

      return {
        id: incident.id,
        type: incident.incidentName,
        position: [
          parseFloat(incident.latitude) || 25.59, // Fallback coordinates if missing
          parseFloat(incident.longitude) || 85.13,
        ],
        severity: incident.severityLevel || "Medium",
        date: formatDate(incident.incidentDateAndTime), // Changed this line
        reporter: incident.reporterName,
        status: incident.event_status,
        description: incident.description,
        affectedServices: incident.affectedServices,
        // Include original data
        originalData: incident,
      };
    });

    // Set the processed data to state
    setMapData({ branches, atms, incidents });
  };

  const mapStateCoordinates = async () => {
    try {
      const res = await getData(gisStateCoordinates + 52); // Assuming 52 is Bihar's state_id

      if (res && res.length > 0) {
        const stateData = res[0];

        // First, try to parse the coordinates
        let coordinates;
        try {
          coordinates = JSON.parse(stateData.coordinates);
        } catch (e) {
          console.error("Failed to parse coordinates:", e);
          return;
        }

        // Create a proper GeoJSON Feature
        const geoJsonData = {
          type: "Feature",
          properties: {
            name: stateData.state_name,
            state_id: stateData.state_id,
          },
          geometry: coordinates,
        };
        setStateGeoJSON(geoJsonData);
      }
    } catch (error) {
      console.error("Error fetching state coordinates:", error);
      toast.error("Failed to load state coordinates");
    }
  };

  const toggleFullscreen = () => {
    if (isFullscreen) {
      handle.exit();
    } else {
      handle.enter();
    }
    setIsFullscreen(!isFullscreen);
  };
  const handleCheckboxChange = (key) => {
    setSelectedLayers((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));

    if (key === "state") {
      const newSelectAll = !selectedLayers.state;
      setSelectAllDistricts(newSelectAll);
      setShowDistricts(newSelectAll);

      const newActiveDistricts = {};
      const districtPromises = [];

      DistrictList.forEach((district) => {
        newActiveDistricts[district.value] = newSelectAll;

        if (newSelectAll) {
          districtPromises.push(
            getData(gisCoordinatesData + district.gis_id)
              .then((response) => {
                if (response && response.length > 0) {
                  const geoJsonData = JSON.parse(response[0].coordinates);
                  setDistrictCoordinates((prev) => ({
                    ...prev,
                    [district.value]: geoJsonData,
                  }));
                }
              })
              .catch((error) => {
                console.error(
                  `Error fetching coordinates for ${district.value}:`,
                  error
                );
                toast.error(`Failed to load coordinates for ${district.value}`);
              })
          );
        }
      });

      setActiveDistricts(newActiveDistricts);

      if (newSelectAll) {
        setLoadingDistricts(true); // Set loading state
        Promise.all(districtPromises)
          .then(() => {
            toast.success("All district data loaded successfully", {
              position: "top-center",
            });
          })
          .catch(() => {
            toast.error("Some district data failed to load", {
              position: "top-center",
            });
          })
          .finally(() => {
            setLoadingDistricts(false); // Clear loading state
          });
      } else {
        setDistrictCoordinates({});
        setLoadingDistricts(false); // Clear loading state
      }
    }
  };
  const handleDistrictToggle = async (districtName) => {
    // First uncheck the state layer if it was checked
    if (selectedLayers.state) {
      setSelectedLayers((prev) => ({ ...prev, state: false }));
      setSelectAllDistricts(false);
    }

    const newActiveDistricts = {
      ...activeDistricts,
      [districtName]: !activeDistricts[districtName],
    };
    setActiveDistricts(newActiveDistricts);
    setShowDistricts(true);

    const district = DistrictList.find((d) => d.value === districtName);

    if (district) {
      if (!activeDistricts[districtName]) {
        try {
          const response = await getData(gisCoordinatesData + district.gis_id);
          if (response && response.length > 0) {
            const geoJsonData = JSON.parse(response[0].coordinates);
            setDistrictCoordinates((prev) => ({
              ...prev,
              [districtName]: geoJsonData,
            }));
          }
        } catch (error) {
          console.error(
            `Error fetching coordinates for ${districtName}:`,
            error
          );
          toast.error(`Failed to load coordinates for ${districtName}`);
        }
      } else {
        const newDistrictCoordinates = { ...districtCoordinates };
        delete newDistrictCoordinates[districtName];
        setDistrictCoordinates(newDistrictCoordinates);
      }
    }

    // Check if all districts are now unchecked
    const allUnchecked = DistrictList.every(
      (district) => !newActiveDistricts[district.value]
    );

    if (allUnchecked) {
      setSelectAllDistricts(false);
    } else {
      const allSelected = DistrictList.every(
        (district) => newActiveDistricts[district.value]
      );
      setSelectAllDistricts(allSelected);
    }
  };
  const fetchDistrictList = async () => {
    try {
      const response = await getData(districtsInGis);
      if (response && Array.isArray(response)) {
        const sortedDistricts = response.sort((a, b) =>
          a.value.localeCompare(b.value)
        );
        setDistrictList(sortedDistricts);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    } finally {
    }
  };

  const geoJsonToLayer = (geoJson) => {
    return L.geoJSON(geoJson, {
      style: {
        color: "#ff7800",
        weight: 2,
        opacity: 1,
        fillColor: "#ff7800",
        fillOpacity: 0.2,
      },
      onEachFeature: (feature, layer) => {
        if (feature.properties && feature.properties.district) {
          layer.bindPopup(feature.properties.district);
        }
      },
    });
  };

  // Find center point for the map based on available branch locations
  const getMapCenter = () => {
    if (mapData.branches && mapData.branches.length > 0) {
      return mapData.branches[0].position;
    }
    // Default center if no branches
    return [25.5941, 85.1376];
  };

  return (
    <FullScreen handle={handle}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <span onClick={toggleFullscreen} className="cursor-pointer">
          <Expand fill="#001b30" width="1.1em" height="1.1em" />
        </span>
      </div>

      <div
        style={{
          display: "flex",
          height: "100vh",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Map Section */}
        <div style={{ flex: 3 }}>
          <MapContainer
            center={getMapCenter()}
            zoom={7}
            style={{ width: "100%", height: "100%" }}
            attributionControl={false}
            onClick={handleMapClick}
            bubblingMouseEvents={true} // Add this line
          >
            <LayersControl position="topright" collapsed={false}>
              <LayersControl.BaseLayer name="Road View">
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="Satellite View">
                <TileLayer
                  attribution="&copy; Google Maps"
                  url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                  maxZoom={20}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer checked name="Terrain View">
                <TileLayer
                  attribution="&copy; Google Maps"
                  url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                  maxZoom={20}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="Hybrid View">
                <TileLayer
                  attribution="&copy; Google Maps"
                  url="https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                  maxZoom={20}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
              </LayersControl.BaseLayer>
            </LayersControl>
            {stateGeoJSON && (
              <GeoJSON
                key={`state-${stateGeoJSON.properties?.state_id || "boundary"}`}
                data={stateGeoJSON}
                style={{
                  color: "#000000",
                  weight: 2,
                  fillColor: "transparent",
                  fillOpacity: 0.2,
                }}
                interactive={false} // Add this to make the layer non-interactive
              />
            )}

            {Object.entries(districtCoordinates).map(
              ([districtName, coordinates]) => (
                <GeoJSON
                  key={districtName}
                  data={coordinates}
                  style={{
                    color:
                      hoveredDistrict === districtName ? "#ff0000" : "#ff7800",
                    weight: hoveredDistrict === districtName ? 3 : 1,
                    opacity: 1,
                    fillColor: "#ff7800",
                    fillOpacity: hoveredDistrict === districtName ? 0.5 : 0.3,
                  }}
                  onEachFeature={(feature, layer) => {
                    layer.on({
                      mouseover: (e) => {
                        setHoveredDistrict(districtName);
                        e.target.setStyle({
                          color: "#ff0000",
                          weight: 3,
                          fillOpacity: 0.5,
                        });
                        e.target.bringToFront();
                      },
                      mouseout: (e) => {
                        setHoveredDistrict(null);
                        e.target.setStyle({
                          color: "#ff7800",
                          weight: 1,
                          fillOpacity: 0.3,
                        });
                      },
                    });

                    // Keep your existing tooltip and popup bindings
                    layer.bindTooltip(districtName, {
                      permanent: false,
                      direction: "top",
                      className: "district-tooltip",
                    });
                    layer.bindPopup(`District: ${districtName}`);
                  }}
                />
              )
            )}
            {activeTab === "Search" && selectedPoint && showRangeCircle && (
              <Circle
                center={selectedPoint}
                radius={kilometerRange * 1000} // Convert km to meters
                pathOptions={{
                  color: "#3388ff",
                  fillColor: "#3388ff",
                  fillOpacity: 0.2,
                  weight: 2,
                }}
              />
            )}

            {activeTab === "Search" && selectedPoint && (
              <Marker
                position={selectedPoint}
                icon={L.divIcon({
                  className: "search-center-marker",
                  html: '<div style="background: #ff0000; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white;"></div>',
                  iconSize: [12, 12],
                  iconAnchor: [6, 6],
                })}
              >
                <Popup>
                  Search Center Point
                  <br />
                  Range: {kilometerRange} km
                </Popup>
              </Marker>
            )}
            <FeatureGroup ref={drawRef}>
              <EditControl
                position="topright"
                onCreated={handleDrawCreated}
                onDeleted={handleDrawDeleted}
                draw={{
                  rectangle: true,
                  polyline: false,
                  polygon: true,
                  circle: false,
                  marker: false,
                  circlemarker: false,
                }}
                edit={{
                  remove: true,
                  edit: false, // Disable editing if not needed
                }}
              />
            </FeatureGroup>

            {/* ATM Markers */}

            {showATMs &&
              combinedFilteredData.atms.map((atm) => (
                <Marker key={atm.id} position={atm.position} icon={atmIcon}>
                  <Popup>
                    <div>
                      <h3>{atm.name}</h3>
                      <p>
                        <strong>District:</strong> {atm.district}
                      </p>
                      <p>
                        <strong>Code:</strong> {atm.code}
                      </p>
                      <p>
                        <strong>Status:</strong> {atm.status}
                      </p>
                      <p>
                        <strong>Address:</strong> {atm.address}
                      </p>
                    </div>
                  </Popup>
                </Marker>
              ))}

            {/* Branch Markers */}
            {showBranches &&
              combinedFilteredData.branches.map((branch) => (
                <Marker
                  key={branch.id}
                  position={branch.position}
                  icon={branchIcon}
                >
                  <Popup>
                    <div>
                      <h3>{branch.name}</h3>
                      <p>
                        <strong>District:</strong> {branch.district}
                      </p>
                      <p>
                        <strong>IFSC:</strong> {branch.ifscCode}
                      </p>
                      <p>
                        <strong>Manager:</strong> {branch.manager}
                      </p>
                      <p>
                        <strong>Contact:</strong> {branch.phones}
                      </p>
                      <p>
                        <strong>Email:</strong> {branch.email}
                      </p>
                      <p>
                        <strong>Address:</strong> {branch.address}
                      </p>
                    </div>
                  </Popup>
                </Marker>
              ))}

            {/* Incident Markers */}
            {showIncidents &&
              combinedFilteredData.incidents.map((incident) => (
                <Marker
                  key={incident.id}
                  position={incident.position}
                  icon={getIncidentIcon(incident.severity)}
                >
                  <Popup>
                    <div>
                      <h3>{incident.type}</h3>
                      <p>
                        <strong>Severity:</strong> {incident.severity}
                      </p>
                      <p>
                        <strong>Date:</strong> {incident.date}
                      </p>
                      <p>
                        <strong>Reporter:</strong> {incident.reporter}
                      </p>
                      <p>
                        <strong>Status:</strong>{" "}
                        {incident.status === 749 || incident.status === null
                          ? "Open"
                          : incident.status === 750 || incident.status === null
                          ? "In Progress"
                          : incident.status === 752 || incident.status === null
                          ? "Closed"
                          : "Unknown"}
                      </p>

                      <p>
                        <strong>Affected Services:</strong>{" "}
                        {incident.affectedServices}
                      </p>
                      <p>
                        <strong>Description:</strong> {incident.description}
                      </p>
                    </div>
                  </Popup>
                </Marker>
              ))}
          </MapContainer>
        </div>

        {/* Right Panel */}
        <div
          style={{
            flex: 1,
            backgroundColor: "#f9f9f9",
            borderLeft: "1px solid #ddd",
            padding: "10px",
            boxSizing: "border-box",
            overflowY: "auto",
            minWidth: "260px",
          }}
        >
          {/* Tabs */}
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {["Region", "Search", "Branch"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  flex: 1,
                  padding: "8px 0",
                  backgroundColor: activeTab === tab ? "#fff" : "#4ba2c7",
                  color: activeTab === tab ? "#4ba2c7" : "#fff",
                  border: activeTab === tab ? "2px solid #4ba2c7" : "none",
                  borderRadius: activeTab === tab ? "8px" : "0px",
                  fontWeight: "bold",
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          {activeTab === "Region" && (
            <>
              {/* Services Panel */}
              <div style={panelStyle}>
                <div
                  style={panelHeader}
                  onClick={() => setShowServices(!showServices)}
                >
                  <span>Services</span>
                  {showServices ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {showServices && (
                  <div style={panelContent}>
                    <div style={checkboxItem}>
                      <input
                        type="checkbox"
                        id="branches"
                        checked={showBranches}
                        onChange={(e) => setShowBranches(e.target.checked)}
                      />
                      <label htmlFor="branches" style={checkboxLabel}>
                        Branches ({mapData.branches.length})
                      </label>
                    </div>

                    <div style={checkboxItem}>
                      <input
                        type="checkbox"
                        id="atms"
                        checked={showATMs}
                        onChange={(e) => setShowATMs(e.target.checked)}
                      />
                      <label htmlFor="atms" style={checkboxLabel}>
                        ATMs ({mapData.atms.length})
                      </label>
                    </div>

                    <div style={checkboxItem}>
                      <input
                        type="checkbox"
                        id="incidents"
                        checked={showIncidents}
                        onChange={(e) => setShowIncidents(e.target.checked)}
                      />
                      <label htmlFor="incidents" style={checkboxLabel}>
                        Incidents ({mapData.incidents.length})
                      </label>
                    </div>

                    <div style={checkboxItem}>
                      <input type="checkbox" disabled id="grievances" />
                      <label
                        htmlFor="grievances"
                        style={{ ...checkboxLabel, color: "#999" }}
                      >
                        Grievances
                      </label>
                    </div>

                    <div style={checkboxItem}>
                      <input type="checkbox" disabled id="devices" />
                      <label
                        htmlFor="devices"
                        style={{ ...checkboxLabel, color: "#999" }}
                      >
                        Devices
                      </label>
                    </div>
                  </div>
                )}
              </div>
              <div style={panelStyle}>
                <div
                  style={panelHeader}
                  onClick={() => setShowRegionHierarchy(!showRegionHierarchy)}
                >
                  <span>Region Hierarchy</span>
                  {showRegionHierarchy ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {showRegionHierarchy && (
                  <div style={panelContent}>
                    <div style={{ marginLeft: 20 }}>
                      <div style={checkboxItem}>
                        <input
                          type="checkbox"
                          id="state"
                          checked={selectAllDistricts}
                          onChange={() => handleCheckboxChange("state")}
                          disabled={loadingDistricts} // Disable when loading
                          style={{ marginRight: "10px" }}
                        />
                        <label htmlFor="state" style={checkboxLabel}>
                          All Districts
                        </label>
                        <button
                          onClick={() => setShowDistricts(!showDistricts)}
                          style={{
                            marginLeft: "auto",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          {showDistricts ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      </div>

                      {showDistricts &&
                        DistrictList.map((district) => (
                          <div
                            key={district.value}
                            style={{
                              marginLeft: 40,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <input
                              type="checkbox"
                              id={district.value}
                              checked={activeDistricts[district.value] || false}
                              onChange={() =>
                                handleDistrictToggle(district.value)
                              }
                              style={{ marginRight: "10px" }}
                            />
                            <label
                              htmlFor={district.value}
                              style={checkboxLabel}
                            >
                              {district.value}
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          {activeTab === "Search" && (
            <>
              {/* Services Panel */}
              <div style={panelStyle}>
                <div
                  style={panelHeader}
                  onClick={() => setShowServices(!showServices)}
                >
                  <span>Services</span>
                  {showServices ? <FaChevronUp /> : <FaChevronDown />}
                </div>

                {showServices && (
                  <div style={panelContent}>
                    <div style={checkboxItem}>
                      <input
                        type="checkbox"
                        id="branches"
                        checked={showBranches}
                        onChange={(e) => setShowBranches(e.target.checked)}
                      />
                      <label htmlFor="branches" style={checkboxLabel}>
                        Branches ({mapData.branches.length})
                      </label>
                    </div>

                    <div style={checkboxItem}>
                      <input
                        type="checkbox"
                        id="atms"
                        checked={showATMs}
                        onChange={(e) => setShowATMs(e.target.checked)}
                      />
                      <label htmlFor="atms" style={checkboxLabel}>
                        ATMs ({mapData.atms.length})
                      </label>
                    </div>

                    <div style={checkboxItem}>
                      <input
                        type="checkbox"
                        id="incidents"
                        checked={showIncidents}
                        onChange={(e) => setShowIncidents(e.target.checked)}
                      />
                      <label htmlFor="incidents" style={checkboxLabel}>
                        Incidents ({mapData.incidents.length})
                      </label>
                    </div>

                    <div style={checkboxItem}>
                      <input type="checkbox" disabled id="grievances" />
                      <label
                        htmlFor="grievances"
                        style={{ ...checkboxLabel, color: "#999" }}
                      >
                        Grievances
                      </label>
                    </div>

                    <div style={checkboxItem}>
                      <input type="checkbox" disabled id="devices" />
                      <label
                        htmlFor="devices"
                        style={{ ...checkboxLabel, color: "#999" }}
                      >
                        Devices
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          {activeTab === "Branch" && (
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "6px",
                padding: "10px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#4ba2c7",
                  color: "#fff",
                  padding: "10px",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: "6px",
                  fontWeight: "bold",
                }}
              >
                Districts
              </div>

              {/* Search Input - Updated with value and onChange */}
              <div style={{ padding: "10px", backgroundColor: "#f1f1f1" }}>
                <input
                  type="text"
                  placeholder="Search Districts"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "6px 10px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>

              {/* Scrollable List of Districts - Updated to use filteredDistricts */}
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  padding: "10px",
                }}
              >
                {filteredDistricts.length > 0 ? (
                  <>
                    {searchTerm && (
                      <div
                        style={{
                          marginBottom: "10px",
                          fontSize: "12px",
                          color: "#666",
                        }}
                      >
                        Found {filteredDistricts.length} district(s)
                      </div>
                    )}
                    {filteredDistricts.map((district) => (
                      <div
                        key={district.value}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          id={`district-${district.value}`}
                          checked={activeDistricts[district.value] || false}
                          onChange={() => handleDistrictToggle(district.value)}
                        />
                        <label
                          htmlFor={`district-${district.value}`}
                          style={{ marginLeft: "8px" }}
                        >
                          {district.value}
                        </label>
                      </div>
                    ))}
                  </>
                ) : DistrictList.length === 0 ? (
                  <div>Loading districts...</div>
                ) : (
                  <div style={{ color: "#666", fontStyle: "italic" }}>
                    No districts found matching "{searchTerm}"
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </FullScreen>
  );
};

const panelStyle = {
  backgroundColor: "#e0eff7",
  borderRadius: "5px",
  marginBottom: "15px",
  overflow: "hidden",
  border: "1px solid #bcdff1",
};

const panelHeader = {
  backgroundColor: "#1a7a73",
  color: "white",
  padding: "8px 12px",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: "bold",
};

const panelContent = {
  padding: "10px 12px",
  backgroundColor: "white",
};

const checkboxItem = {
  display: "flex",
  alignItems: "center",
  marginBottom: "8px",
};

const checkboxLabel = {
  display: "flex",
  alignItems: "center",
  marginLeft: "5px",
  cursor: "pointer",
  marginTop: "3px",
};

export default MapUI;
